// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface CollectionPatientAccount
 */
export interface CollectionPatientAccount {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    id?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    externalPatientId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    patientFirst?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    patientMiddle?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    patientLast?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    patientSuffix?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof CollectionPatientAccount
     */
    patientDob?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    guarantorFirst?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    guarantorMiddle?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    guarantorLast?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    guarantorSuffix?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof CollectionPatientAccount
     */
    guarantorDob?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    mailingName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    mailingAddressLine1?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    mailingAddressLine2?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    mailingAddressLine3?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    mailingCity?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    mailingState?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    mailingPostalCode?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    mailingCountry?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    patientName?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    patientAddressLine1?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    patientAddressLine2?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    patientAddressLine3?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    patientCity?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    patientState?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    patientPostalCode?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    patientCountry?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    email?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    phone?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    guarantorRelationshipType?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof CollectionPatientAccount
     */
    collectionIntegrationId?: string;
}

export function CollectionPatientAccountFromJSON(json: any): CollectionPatientAccount {
    return {
            'id': !exists(json, 'id') ? undefined : json['id'],
            'externalPatientId': !exists(json, 'externalPatientId') ? undefined : json['externalPatientId'],
            'patientFirst': !exists(json, 'patientFirst') ? undefined : json['patientFirst'],
            'patientMiddle': !exists(json, 'patientMiddle') ? undefined : json['patientMiddle'],
            'patientLast': !exists(json, 'patientLast') ? undefined : json['patientLast'],
            'patientSuffix': !exists(json, 'patientSuffix') ? undefined : json['patientSuffix'],
            'patientDob': !exists(json, 'patientDob') ? undefined : json['patientDob'],
            'guarantorFirst': !exists(json, 'guarantorFirst') ? undefined : json['guarantorFirst'],
            'guarantorMiddle': !exists(json, 'guarantorMiddle') ? undefined : json['guarantorMiddle'],
            'guarantorLast': !exists(json, 'guarantorLast') ? undefined : json['guarantorLast'],
            'guarantorSuffix': !exists(json, 'guarantorSuffix') ? undefined : json['guarantorSuffix'],
            'guarantorDob': !exists(json, 'guarantorDob') ? undefined : json['guarantorDob'],
            'mailingName': !exists(json, 'mailingName') ? undefined : json['mailingName'],
            'mailingAddressLine1': !exists(json, 'mailingAddressLine1') ? undefined : json['mailingAddressLine1'],
            'mailingAddressLine2': !exists(json, 'mailingAddressLine2') ? undefined : json['mailingAddressLine2'],
            'mailingAddressLine3': !exists(json, 'mailingAddressLine3') ? undefined : json['mailingAddressLine3'],
            'mailingCity': !exists(json, 'mailingCity') ? undefined : json['mailingCity'],
            'mailingState': !exists(json, 'mailingState') ? undefined : json['mailingState'],
            'mailingPostalCode': !exists(json, 'mailingPostalCode') ? undefined : json['mailingPostalCode'],
            'mailingCountry': !exists(json, 'mailingCountry') ? undefined : json['mailingCountry'],
            'patientName': !exists(json, 'patientName') ? undefined : json['patientName'],
            'patientAddressLine1': !exists(json, 'patientAddressLine1') ? undefined : json['patientAddressLine1'],
            'patientAddressLine2': !exists(json, 'patientAddressLine2') ? undefined : json['patientAddressLine2'],
            'patientAddressLine3': !exists(json, 'patientAddressLine3') ? undefined : json['patientAddressLine3'],
            'patientCity': !exists(json, 'patientCity') ? undefined : json['patientCity'],
            'patientState': !exists(json, 'patientState') ? undefined : json['patientState'],
            'patientPostalCode': !exists(json, 'patientPostalCode') ? undefined : json['patientPostalCode'],
            'patientCountry': !exists(json, 'patientCountry') ? undefined : json['patientCountry'],
            'email': !exists(json, 'email') ? undefined : json['email'],
            'phone': !exists(json, 'phone') ? undefined : json['phone'],
            'guarantorRelationshipType': !exists(json, 'guarantorRelationshipType') ? undefined : json['guarantorRelationshipType'],
            'collectionIntegrationId': !exists(json, 'collectionIntegrationId') ? undefined : json['collectionIntegrationId'],
    };

}

export function CollectionPatientAccountToForm(value?: CollectionPatientAccount): any {
    let jsonVal = CollectionPatientAccountToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function CollectionPatientAccountToJSON(value?: CollectionPatientAccount): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'externalPatientId': cleanupBlankValuesForBackend(value.externalPatientId),
            'patientFirst': cleanupBlankValuesForBackend(value.patientFirst),
            'patientMiddle': cleanupBlankValuesForBackend(value.patientMiddle),
            'patientLast': cleanupBlankValuesForBackend(value.patientLast),
            'patientSuffix': cleanupBlankValuesForBackend(value.patientSuffix),
            'patientDob': cleanupBlankValuesForBackend(value.patientDob),
            'guarantorFirst': cleanupBlankValuesForBackend(value.guarantorFirst),
            'guarantorMiddle': cleanupBlankValuesForBackend(value.guarantorMiddle),
            'guarantorLast': cleanupBlankValuesForBackend(value.guarantorLast),
            'guarantorSuffix': cleanupBlankValuesForBackend(value.guarantorSuffix),
            'guarantorDob': cleanupBlankValuesForBackend(value.guarantorDob),
            'mailingName': cleanupBlankValuesForBackend(value.mailingName),
            'mailingAddressLine1': cleanupBlankValuesForBackend(value.mailingAddressLine1),
            'mailingAddressLine2': cleanupBlankValuesForBackend(value.mailingAddressLine2),
            'mailingAddressLine3': cleanupBlankValuesForBackend(value.mailingAddressLine3),
            'mailingCity': cleanupBlankValuesForBackend(value.mailingCity),
            'mailingState': cleanupBlankValuesForBackend(value.mailingState),
            'mailingPostalCode': cleanupBlankValuesForBackend(value.mailingPostalCode),
            'mailingCountry': cleanupBlankValuesForBackend(value.mailingCountry),
            'patientName': cleanupBlankValuesForBackend(value.patientName),
            'patientAddressLine1': cleanupBlankValuesForBackend(value.patientAddressLine1),
            'patientAddressLine2': cleanupBlankValuesForBackend(value.patientAddressLine2),
            'patientAddressLine3': cleanupBlankValuesForBackend(value.patientAddressLine3),
            'patientCity': cleanupBlankValuesForBackend(value.patientCity),
            'patientState': cleanupBlankValuesForBackend(value.patientState),
            'patientPostalCode': cleanupBlankValuesForBackend(value.patientPostalCode),
            'patientCountry': cleanupBlankValuesForBackend(value.patientCountry),
            'email': cleanupBlankValuesForBackend(value.email),
            'phone': cleanupBlankValuesForBackend(value.phone),
            'guarantorRelationshipType': cleanupBlankValuesForBackend(value.guarantorRelationshipType),
            'collectionIntegrationId': cleanupBlankValuesForBackend(value.collectionIntegrationId),
    };
}


